import { useMemo } from "react";
import { useAuthContext } from "../../auth/AuthContext";
import { jwtDecode } from "jwt-decode";
import { Button, Col, Modal, ModalFooter, Row } from "react-bootstrap";
import { StyledModalTitle } from "../../../@ui/StyledModalTitle";
import ThemedModal from "../../../@ui/Modal/ThemedModal";

export interface LicenceModalProps {
  show: boolean;
  onHide: () => void;
}

const getLicenceTypeLabel = (licenceType: string) => {
  switch (licenceType) {
    case "SingleUser":
      return "Single User";
    default:
      return licenceType;
  }
};

const LicenceModal = ({ show, onHide }: LicenceModalProps) => {
  const { user } = useAuthContext();
  const { license, licenseType, expiry } = useMemo(() => {
    if (user?.token) {
      const tokenPayload = jwtDecode(user.token) as any;
      return {
        license: tokenPayload.LicenceName,
        licenseType: getLicenceTypeLabel(tokenPayload.LicenceType),
        expiry: tokenPayload.LicenceExpiry,
      };
    }

    return { license: undefined, licenseType: undefined, expiry: undefined };
  }, [user]);

  return (
    <ThemedModal centered show={show} onHide={onHide} backdrop="static">
      <Modal.Header className="bg-secondary text-white" closeButton>
        <StyledModalTitle>Your Current DataCutter Licence</StyledModalTitle>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md="5">
            <strong>Licence</strong>
          </Col>
          <Col>{license}</Col>
        </Row>
        <Row>
          <Col md="5">
            <strong>Licence Type</strong>
          </Col>
          <Col>{licenseType}</Col>
        </Row>
        <Row>
          <Col md="5">
            <strong>Licence Expiry</strong>
          </Col>
          <Col>{expiry}</Col>
        </Row>
      </Modal.Body>
      <ModalFooter>
        <Button variant="primary" onClick={onHide}>
          Close
        </Button>
      </ModalFooter>
    </ThemedModal>
  );
};

export default LicenceModal;
